/* tslint:disable */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AngularFireDatabase } from 'angularfire2/database';
import { FirebaseApp } from 'angularfire2';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http } from '@angular/http';
import { DatePipe } from '@angular/common';
import { shareReplay, map, tap, delay } from 'rxjs/operators';

@Injectable()
export class GenProvider {
  public parametros: any;
  public permissao: any;
  public frmActive: any;
  constructor(
    public http: Http,
    public db: AngularFireDatabase,
    public auth: AngularFireAuth,
    private fb: FirebaseApp,
    private afs: AngularFirestore
  ) {
    this.frmActive = '';
    let user = {
      email: 'login@login.com',
      password: '123456'
    };
    /*
        this.auth.auth
          .signInWithEmailAndPassword(user.email, user.password)
          .then(() => {
        //    console.log('Autenticado');
          })
          .catch((error: any) => {
            alert('Erro na autenticação ' + error.code);
          });
          */
  }
  onCriarContadores(path) {
    let dados = {
      nova: 0,
      visualizada: 0,
      finalizada: 0,
      total: 0
    }
    // console.log ("criar tabelas")
    let startMsg = this.onGet('dados/' + path, 'mensagemCount')
      .subscribe(
        data => {
          startMsg.unsubscribe();
          //   console.log (data)
          let isTabela = data.length;
          if (isTabela > 0) {
          } else {
            //   console.log ("Criar Tabelas")
            // criar tabela de contadores
            this.onSaveDocKey('dados/' + path + '/mensagemCount', 'ouvidoria', dados) // atualiza o registro com a mesma chave
            this.onSaveDocKey('dados/' + path + '/mensagemCount', 'mensagem', dados) // atualiza o registro com a mesma chave
            this.onSaveDocKey('dados/' + path + '/mensagemCount', 'atendimento', dados) // atualiza o registro com a mesma chave
          }
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );

  }
  // https:/httpbin.org/post -> testar envio de dados
  onParametros(data) {
    this.onCriarContadores(data.path);
    this.onLoadPermissao(data.key_login)
    let parametros = {
      key: null,
      path: data.path,
      nivel: data.nivel,
      nome: data.nome,
      grupo: data.grupo,
      key_grupo: data.key_grupo,
      key_login: data.key_login,
      key_usuario: data.key
    }
    this.parametros = JSON.parse(JSON.stringify(parametros));
    this.onGetAll('dados/' + data.path + '/parametros', 'token').subscribe(res => {
      let dados = JSON.parse(JSON.stringify(res));
      let parametros: any;
      if (dados.length > 0) {
        parametros = {
          key: dados[0].key,
          intervalo_msg_recebida : dados[0].intervalo_msg_recebida,
          intervalo_inicio: dados[0].intervalo_inicio,
          intervalo_fim: dados[0].intervalo_fim,
          apos: dados[0].apos,
          pausar: dados[0].pausar,
          saudacao: dados[0].saudacao,
          hora_inicio: dados[0].hora_inicio,
          hora_fim: dados[0].hora_fim,
          semana: dados[0].semana,
          sabado: dados[0].sabado,
          domingo: dados[0].domingo,
          servidor: dados[0].servidor,
          instancia: dados[0].instancia,
          token: dados[0].token,
          telefone: dados[0].telefone,
          request: dados[0].request,
          menu_automatico: dados[0].menu_automatico,
          menu_automatico_tempo: dados[0].menu_automatico_tempo,
          plataforma : dados[0].plataforma,
          path: data.path,
          nivel: data.nivel,
          nome: data.nome,
          grupo: data.grupo,
          key_grupo: data.key_grupo,
          key_login: data.key_login,
          key_usuario: data.key,
          webhookUrl: dados[0].webhookUrl,
          webhookDenuncia: dados[0].webhookDenuncia,
          webhookMensagem: dados[0].webhookMensagem,
          webhookOuvidoria: dados[0].webhookOuvidoria,
          webhookSetor : dados[0].webhookSetor,
          whatsMensagem: dados[0].whatsMensagem,
          whatsDenuncia: dados[0].whatsDenuncia,
          whatsOuvidoria: dados[0].whatsOuvidoria,
          tokenFace : dados[0].tokenFace,
          userIdFace : dados[0].userIdFace,
          intervalo_live: dados[0].intervalo_live,
          apos_live: dados[0].apos_live,
          pausar_live : dados[0].pausar_live,
          saudacao_live: dados[0].saudacao_live,
          key_intervalo: dados[0].key_intervalo,
          key_puc: dados[0].key_puc,
          key_lotacao: dados[0].key_lotacao,
          nome_puc : dados[0].nome_puc,
          filaAgente: dados[0].filaAgente,
          mostra_numero_menu: dados[0].mostra_numero_menu

        }
        this.parametros = JSON.parse(JSON.stringify(parametros));
      } else {
        parametros = {
          key: null,
          path: data.path,
          nivel: data.nivel,
          nome: data.nome,
          grupo: data.grupo,
          key_grupo: data.key_grupo,
          key_login: data.key_login,
          key_usuario: data.key
        }
        this.parametros = JSON.parse(JSON.stringify(parametros));
      }

    },
      err => console.log(err)
    );

  };

  onLoadPermissao(key) {
    if (key) {
      this.onGetFilterOrder('login_permissao', 'nome', 'key_login', key)
        .subscribe(data => {
          this.permissao = JSON.parse(JSON.stringify(data))
        });
    }
  }
  filtroPermissao(formulario) {
    return new Promise(resolve => {
      try {
        let tmp = this.permissao.filter(obj => {
          return obj.nome == formulario;
        });
        if (tmp.length > 0) {
          resolve(tmp[0]);
        } else {
          if (this.parametros.nivel = '99') {
            let permissao = {
              nome: formulario,
              per_bloqueio: false,
              per_inserir: true,
              per_alterar: true,
              per_excluir: true,
              per_imprimir: true,
              per_visualizar: true
            }
            resolve(permissao);
          } else {
            let permissao = {
              nome: formulario,
              per_bloqueio: true,
              per_inserir: false,
              per_alterar: false,
              per_excluir: false,
              per_imprimir: false,
              per_visualizar: false
            }
            resolve(permissao);
          }
        }
      } catch (error) {
        if (this.parametros.nivel = '99') {
          let permissao = {
            nome: formulario,
            per_bloqueio: false,
            per_inserir: true,
            per_alterar: true,
            per_excluir: true,
            per_imprimir: true,
            per_visualizar: true
          }
          resolve(permissao);
        } else {
          let permissao = {
            nome: formulario,
            per_bloqueio: true,
            per_inserir: false,
            per_alterar: false,
            per_excluir: false,
            per_imprimir: false,
            per_visualizar: false
          }
          resolve(permissao);
        }
      }

    })
  }
  getEstados() {
    let uf = [
      { nome: 'Acre', sigla: 'AC' },
      { nome: 'Alagoas', sigla: 'AL' },
      { nome: 'Amapá', sigla: 'AP' },
      { nome: 'Amazonas', sigla: 'AM' },
      { nome: 'Bahia', sigla: 'BA' },
      { nome: 'Ceará', sigla: 'CE' },
      { nome: 'Distrito Federal', sigla: 'DF' },
      { nome: 'Espírito Santo', sigla: 'ES' },
      { nome: 'Goiás', sigla: 'GO' },
      { nome: 'Maranhão', sigla: 'MA' },
      { nome: 'Mato Grosso', sigla: 'MT' },
      { nome: 'Mato Grosso do Sul', sigla: 'MS' },
      { nome: 'Minas Gerais', sigla: 'MG' },
      { nome: 'Pará', sigla: 'PA' },
      { nome: 'Paraíba', sigla: 'PB' },
      { nome: 'Paraná', sigla: 'PR' },
      { nome: 'Pernambuco', sigla: 'PE' },
      { nome: 'Piauí', sigla: 'PI' },
      { nome: 'Rio de Janeiro', sigla: 'RJ' },
      { nome: 'Rio Grande do Norte', sigla: 'RN' },
      { nome: 'Rio Grande do Sul', sigla: 'RS' },
      { nome: 'Rondônia', sigla: 'RO' },
      { nome: 'Roraima', sigla: 'RR' },
      { nome: 'Santa Catarina', sigla: 'SC' },
      { nome: 'São Paulo', sigla: 'SP' },
      { nome: 'Sergipe', sigla: 'SE' },
      { nome: 'Tocantins', sigla: 'TO' }
    ];
    return uf;
  }
  // crud firebase
  onGetAll2(PATH: string, order: string) {
    return this.afs
      .collection(PATH, ref => ref.orderBy(order))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  onGetAll(PATH: string, order: string, array?: any) {
    return this.afs.collection(PATH, ref => ref.orderBy(order)).snapshotChanges(['added', 'removed','modified'])
      .pipe(
       // tap(console.log),
        map((changes: any) => {
          let data = changes.map((c: any) =>
          ({
            key: c.payload.doc.id,
            ...c.payload.doc.data() as {}
          })
          )
          return data
        })
      )
  }
  onGetfilter(PATH: string, filtro: string, valor: any) {
    return this.afs
      .collection(PATH, ref => ref.where(filtro, '==', valor))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  getFilter(PATH: string, filtro: string, valor: any) {
    return new Promise((resolve, reject) => {
      return this.afs.collection(PATH, ref => ref.where(filtro, '==', valor))
        .snapshotChanges()
        .map(changes => {
          let res = changes.map(c => ({
            key: c.payload.doc.id,
            ...c.payload.doc.data()
          }));
          resolve(res);
        });
    });
  }

  onGetFilterOrder(PATH: string, order: string, filtro: string, valor: any, operador?: string) {
    if (operador == '<=') {
      return this.afs
        .collection(PATH, ref =>
          ref.orderBy(order, 'asc').orderBy(filtro).endAt(valor)
        )
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => ({
            key: c.payload.doc.id,
            ...c.payload.doc.data()
          }));
        });

    } else
      if (operador == '>=') {
        return this.afs
          .collection(PATH, ref =>
            ref.orderBy(filtro).startAt(valor)
          )
          .snapshotChanges()
          .map(changes => {
            return changes.map(c => ({
              key: c.payload.doc.id,
              ...c.payload.doc.data()
            }));
          });
      } else
        if (operador == '==') {
          return this.afs
            .collection(PATH, ref =>
              ref.where(filtro, '==', valor).orderBy(order, 'asc')
            )
            .snapshotChanges()
            .map(changes => {
              return changes.map(c => ({
                key: c.payload.doc.id,
                ...c.payload.doc.data()
              }));
            });
        } else {
          return this.afs
            .collection(PATH, ref =>
              ref.where(filtro, '==', valor).orderBy(order, 'asc')
            )
            .snapshotChanges()
            .map(changes => {
              return changes.map(c => ({
                key: c.payload.doc.id,
                ...c.payload.doc.data()
              }));
            });
        }
  }
  onGetFilterOrderDesc(PATH: string, order: string, filtro: string, valor: any, operador?: string) {
    if (operador == '<=') {
      return this.afs
        .collection(PATH, ref =>
          ref.orderBy(order, 'desc').orderBy(filtro).endAt(valor)
        )
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => ({
            key: c.payload.doc.id,
            ...c.payload.doc.data()
          }));
        });

    } else
      if (operador == '>=') {
        return this.afs
          .collection(PATH, ref =>
            ref.orderBy(filtro).startAt(valor)
          )
          .snapshotChanges()
          .map(changes => {
            return changes.map(c => ({
              key: c.payload.doc.id,
              ...c.payload.doc.data()
            }));
          });
      } else
        if (operador == '==') {
          return this.afs
            .collection(PATH, ref =>
              ref.where(filtro, '==', valor).orderBy(order, 'desc')
            )
            .snapshotChanges()
            .map(changes => {
              return changes.map(c => ({
                key: c.payload.doc.id,
                ...c.payload.doc.data()
              }));
            });
        } else {
          return this.afs
            .collection(PATH, ref =>
              ref.where(filtro, '==', valor).orderBy(order, 'desc')
            )
            .snapshotChanges()
            .map(changes => {
              return changes.map(c => ({
                key: c.payload.doc.id,
                ...c.payload.doc.data()
              }));
            });
        }
  }

  onGetAllFilterPageDesc(
    PATH: string,
    order: string,
    filtro: string,
    valor: any,
    page: number
  ) {
    return this.afs
      .collection(PATH, ref =>
        ref
          .orderBy(order, 'desc')
          .where(filtro, '==', valor)
          .limit(page)
      )
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  onGetAllFilterPage(PATH: string, filtro: string, valor: any, page: number) {
    return this.afs
      .collection(PATH, ref => ref.where(filtro, '==', valor).limit(page))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  onGetAllPageDesc(PATH: string, order: string, page: number) {
    return this.afs
      .collection(PATH, ref => ref.orderBy(order, 'desc').limit(page))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  onGetAllPage(PATH: string, order: string, page: number) {
    return this.afs
      .collection(PATH, ref => ref.orderBy(order).limit(page))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }

  onGetAllObjeto(
    PATH: string,
    key: string,
    objeto: string,
    order: string,
    page?: number
  ) {
    return this.afs
      .collection(PATH)
      .doc(key)
      .collection(objeto, ref => ref.orderBy(order).limit(page || 999999))
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }

  onGetAllObjetoDesc(
    PATH: string,
    key: string,
    objeto: string,
    order: string,
    page?: number
  ) {
    return this.afs
      .collection(PATH)
      .doc(key)
      .collection(objeto, ref =>
        ref.orderBy(order, 'desc').limit(page || 999999)
      )
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }

  onSave(PATH, parametro: any) {
    //   let data = parametro;
    let data = JSON.parse(JSON.stringify(parametro));
    delete data['key'];
    return new Promise((resolve, reject) => {
      if (parametro.key) {
        this.afs
          .collection(PATH)
          .doc(parametro.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH)
          .add(data)
          .then(res => {
            resolve(res.id); // chamando ADD gera um key automatico
          });
      }
    });
  }

  onSaveObjeto(PATH: string, key: string, objeto: string, parametro) {
    let data = JSON.parse(JSON.stringify(parametro));
    delete data['key'];
    return new Promise((resolve, reject) => {
      if (parametro.key) {
        this.afs
          .collection(PATH)
          .doc(key)
          .collection(objeto)
          .doc(parametro.key)
          .update(data)
          .then(res => {
            resolve(parametro.key); // chamando ADD gera um key automatico
          }).catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH)
          .doc(key)
          .collection(objeto)
          .add(data)
          .then(res => {
            resolve(res.id); // chamando ADD gera um key automatico
          });
      }
    });
  }


  onSaveDoc(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve(null))
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.uid)
          .set(data)
          .then(res=>() => resolve());
      }
    });
  }
  onSaveDocListaTransmissao(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.key_campanha)
          .set(data)
          .then(() => resolve());
      }
    });
  }

  onSaveDocPesquisa(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.key_pesquisa)
          .set(data)
          .then(() => resolve());
      }
    });
  }

  onSaveDocEnquete(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.key_enquete)
          .set(data)
          .then(() => resolve());
      }
    });
  }

  onSaveDocPergunta(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.key_pergunta)
          .set(data)
          .then(() => resolve());
      }
    });
  }


  onSaveDocQuestionario(PATH, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(data.key_questionario)
          .set(data)
          .then(() => resolve());
      }
    });
  }

  removeCollection(PATH, collection: any) {
    return new Promise((resolve, reject) => {
      this.afs.collection(PATH).doc(collection)
        .delete()
        .then(() => {
          resolve();
   //**     console.log('Document successfully deleted!');
        })
        .catch(function (error) {
          reject(error);
          console.error('Error removing document: ', error);
        });
    });
  }

  remove(PATH, key: any) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection(PATH)
        .doc(key)
        .delete()
        .then(() => {
          resolve();
       //**   console.log('Document successfully deleted!');
        })
        .catch(function (error) {
          reject(error);
          console.error('Error removing document: ', error);
        });
    });
  }

  removeObjeto(PATH: string, key: any, objeto: string, id: string) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection(PATH)
        .doc(key)
        .collection(objeto)
        .doc(id)
        .delete()
        .then(() => {
          resolve();
          console.log('Document successfully deleted!');
        })
        .catch(function (error) {
          reject(error);
          console.error('Error removing document: ', error);
        });
    });
  }

  removeFile(PATH, key: string, fullPath: string) {
    console.log('remover ' + key);
    return this.afs
      .collection(PATH)
      .doc(key)
      .delete()
      .then(() => {
        this.removeOnFile(fullPath);
      });
  }

  removeOnFile(fullPath: string) {
    console.log('remover foto ' + fullPath);
    if (fullPath != null || fullPath) {
      let storageRef = this.fb.storage().ref();
      storageRef.child(fullPath).delete();
    }
  }

  statusUsuario() {
    return this.auth.authState.subscribe(user => {
      //      return (this.usuario = user);
    });
  }

  public getUid() {
    if (this.auth.auth.currentUser) {
      return this.auth.auth.currentUser.uid;
    } else {
      return 'Não Logado';
    }
  }

  onSaveDocKey(PATH, key: string, data: any) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        this.afs
          .collection(PATH + '/')
          .doc(key)
          .set(data)
          .then(() => resolve());
      }
    });
  }
  onAtualizaContador(PATH, key) {
    const sfDocRef = this.afs.firestore.collection(PATH).doc(key);
    return this.afs.firestore.runTransaction(transaction =>
      transaction.get(sfDocRef)
        .then(sfDoc => {
          let newcontador = 0;
          if (sfDoc.data().contador) {
            newcontador = sfDoc.data().contador + 1;
          } else {
            newcontador = 1;
          }
          return transaction.update(sfDocRef, { contador: newcontador });
        })).then(() => console.log("Transaction successfully committed!"))
      .catch(error => console.log("Transaction failed: ", error));
  }
  onUpdateMsgEnviada(PATH, key) {
    const sfDocRef = this.afs.firestore.collection(PATH).doc(key);
    return this.afs.firestore.runTransaction(transaction =>
      transaction.get(sfDocRef)
        .then(sfDoc => {
          let newcontador = 0;
          if (sfDoc.data().msgEnviada) {
            newcontador = sfDoc.data().msgEnviada + 1;
          } else {
            newcontador = 1;
          }
          return transaction.update(sfDocRef, { msgEnviada: newcontador });
        })).then(() => console.log("Transaction successfully committed!"))
      .catch(error => console.log("Transaction failed: ", error));
  }
  onUpdateVoto(PATH, key) {
    const sfDocRef = this.afs.firestore.collection(PATH).doc(key);
    return this.afs.firestore.runTransaction(transaction =>
      transaction.get(sfDocRef)
        .then(sfDoc => {
          let newcontador = 0;
          if (sfDoc.data().votos) {
            newcontador = sfDoc.data().votos + 1;
          } else {
            newcontador = 1;
          }
          return transaction.update(sfDocRef, { votos: newcontador });
        })).then(() => console.log("Transaction successfully committed!"))
      .catch(error => console.log("Transaction failed: ", error));
  }

  onUpdateMsgEntregue(PATH, key) {
    const sfDocRef = this.afs.firestore.collection(PATH).doc(key);
    return this.afs.firestore.runTransaction(transaction =>
      transaction.get(sfDocRef)
        .then(sfDoc => {
          let newcontador = 0;
          if (sfDoc.data().msgEntregue) {
            newcontador = sfDoc.data().msgEntregue + 1;
          } else {
            newcontador = 1;
          }
          return transaction.update(sfDocRef, { msgEntregue: newcontador });
        })).then(() => console.log("Transaction successfully committed!"))
      .catch(error => console.log("Transaction failed: ", error));
  }
  onUpdateMsgFalha(PATH, key) {
    const sfDocRef = this.afs.firestore.collection(PATH).doc(key);
    return this.afs.firestore.runTransaction(transaction =>
      transaction.get(sfDocRef)
        .then(sfDoc => {
          let newcontador = 0;
          if (sfDoc.data().msgFalha) {
            newcontador = sfDoc.data().msgFalha + 1;
          } else {
            newcontador = 1;
          }
          return transaction.update(sfDocRef, { msgFalha: newcontador });
        })).then(() => console.log("Transaction successfully committed!"))
      .catch(error => console.log("Transaction failed: ", error));
  }
  onGet(PATH: string, key: string) {
    return this.afs
      .collection(PATH + '/' + key)
      .snapshotChanges()
      .map(changes => {
        return changes.map(c => ({
          key: c.payload.doc.id,
          ...c.payload.doc.data()
        }));
      });
  }
  onGetKey(PATH: string, key: string) {
    return this.afs.doc(PATH + '/' + key).snapshotChanges().map(c => {
      return { key: c.payload.id, ...c.payload.data() };
    });

  }
  onIncrementKey(PATH, TABLE) {
    return new Promise(async (resolve, reject) => {
      const sfDocRef = this.afs.firestore.collection(PATH + '/incrementKey').doc(TABLE);
      try {
        const result = await this.afs.firestore.runTransaction(t => {
          return t.get(sfDocRef).then((doc: any) => {
            if (doc.data()) {
              let newKey = doc.data().countKey;
              newKey++;
              let dados = {
                countKey: newKey
              };
              t.update(sfDocRef, dados);
              resolve(dados.countKey.toString());
            }
            else {
              let dados_1 = {
                countKey: 1
              };
              t.set(sfDocRef, dados_1);
              resolve(dados_1.countKey.toString());
            }
          });
        });
        //  console.log('Transaction sucesso', result);
      }
      catch (err) {
        //  console.log('Transaction falha:', err);
      }
    });
  };
  onIncrementKeyDateTime() {
    return new Promise(async (resolve) => {
      let key = new DatePipe('pt-BR').transform(Date.now(),'yyyyMMdd')+'.'+this.parametros.key_usuario+'.'+new DatePipe('pt-BR').transform(Date.now(),'HHmmssSSS')
      resolve(key);
    });
  };
  onIncrementKeyZeroDate(PATH, table: string, length: number) {
    return new Promise(async (resolve, reject) => {
      const sfDocRef = this.afs.firestore.collection(PATH + '/incrementKey').doc(table);
      try {
        const result = await this.afs.firestore.runTransaction(t => {
          return t.get(sfDocRef).then((doc: any) => {
            if (doc.data()) {
              let newKey = doc.data().countKey;
              newKey++;
              if (newKey==1000000){
                newKey = 1
              }
              let dados = {
                countKey: newKey
              };
              t.update(sfDocRef, dados);
              this.pad(dados.countKey.toString(), length).then(key => {
                let keyValue = new DatePipe('pt-BR').transform(Date.now(),'yyyyMMdd')+'.'+this.parametros.key_usuario+'.'+key
                resolve(keyValue);
              })
            }
            else {
              let dados_1 = {
                countKey: 1
              };
              t.set(sfDocRef, dados_1);
              resolve(dados_1.countKey.toString());
            }
          });
        });
        //  console.log('Transaction sucesso', result);
      }
      catch (err) {
        //  console.log('Transaction falha:', err);
      }
    });
  };
  onIncrementKeyZero(PATH,  table: string, length: number) {
    return new Promise(async (resolve, reject) => {
      const sfDocRef = this.afs.firestore.collection(PATH + '/incrementKey').doc(table);
      try {
        const result = await this.afs.firestore.runTransaction(t => {
          return t.get(sfDocRef).then((doc: any) => {
            if (doc.data()) {
              let newKey = doc.data().countKey;
              newKey++;
              if (newKey==1000000){
                newKey = 1
              }
              let dados = {
                countKey: newKey
              };
              t.update(sfDocRef, dados);
              this.pad(dados.countKey.toString(), length).then(key => {
                resolve(key);
              })
            }
            else {
              let dados_1 = {
                countKey: 1
              };
              t.set(sfDocRef, dados_1);
              this.pad(dados_1.countKey.toString(), length).then(key => {
                resolve(key);
              })
            }
          });
        });
        //  console.log('Transaction sucesso', result);
      }
      catch (err) {
        //  console.log('Transaction falha:', err);
      }
    });
  };
  onSaveIncrement(PATH, data: any, table: string) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then((res:any)=> resolve(res))
          .catch(e => reject(e));
      } else {
        delete data["key"];
        this.onIncrementKey('dados/' + this.parametros.path, table).then((keyValue: any) => {
          this.afs.collection(PATH + '/').doc(keyValue).set(data).then(() => resolve(keyValue));
        });
      }
    });
  }
  onSaveIncrementDate(PATH, data: any, table: string) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve(null))
          .catch(e => reject(e));
      } else {
        delete data["key"];
        this.onIncrementKey('dados/' + this.parametros.path, table).then((keyValue: any) => {
          this.afs.collection(PATH + '/').doc(keyValue).set(data).then(() => resolve(keyValue));
        });
      }
    });
  }
  onSaveIncrementZero(PATH, data: any, table: string, length: number) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve(null))
          .catch(e => reject(e));
      } else {
        delete data["key"];
        this.onIncrementKeyZero('dados/' + this.parametros.path, table, length).then((keyValue: any) => {
          this.afs.collection(PATH + '/').doc(keyValue).set(data).then(() => resolve(keyValue));
        });
      }
    });
  }
  onSaveIncrementZeroDate(PATH, data: any, table: string, length) {
    return new Promise((resolve, reject) => {
      if (data.key) {
        this.afs
          .collection(PATH + '/')
          .doc(data.key)
          .update(data)
          .then(() => resolve(null))
          .catch(e => reject(e));
      } else {
        delete data["key"];
        this.onIncrementKeyDateTime().then((key: any) => {
          this.afs.collection(PATH + '/').doc(key).set(data).then(() => resolve(key));
        });
      }
    });
  }

  pad(str, length) {
    return new Promise(async (resolve, reject) => {
      var adicionar = length - str.length;
      for (var i = 0; i < adicionar; i++) str = '0' + str;
      resolve(str.slice(0, length));
    });
  }
}
/*
window.setTimeout(function() {
    clearInterval(this.intervalo);
}, 3000);
*/



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/providers/gen/gen.ts